import { I as Icon, _ as __assign } from './loadable.esm-a015de77.js';
import React__default from 'react';
import 'styled-components';

var ToggleIcon = function (props) { return (React__default.createElement(Icon, __assign({}, props, { viewBox: "0 0 16 16" }),
    React__default.createElement("path", { d: "M9 4H7v3H4v2h3v3h2V9h3V7H9z" }),
    React__default.createElement("path", { d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z" }))); };

var ToggleIcon$1 = ToggleIcon;

export { ToggleIcon$1 as default };
//# sourceMappingURL=ToggleIcon-b44fe588.js.map
